import { colors } from '../../colors';
var pencilBanner = {
  bgColor: colors.nvaTeal,
  textColor: colors.white,
  textColorDark: colors.nvaBlack,
  textColorLight: colors.white
};
export default pencilBanner;